import isEmail from 'validator/lib/isEmail';
import {validateMaxLength} from '../../common/validationUtils';
import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";

export const ContactPersonValidator = values => {
    let errors = {};

    if (!values.workingTitle) {
        errors.workingTitle = plainJSTranslator.formatMessage(messages.required);
    } else if (values.workingTitle.length < 3) {
        errors.workingTitle = plainJSTranslator.formatMessage(messages.errorTooShort3);
    }
    if (!values.name) {
        errors.name = plainJSTranslator.formatMessage(messages.required);
    } else if (values.name.length < 3) {
        errors.name = plainJSTranslator.formatMessage(messages.errorTooShort3);
    }
    if (!values.email) {
        errors.email = plainJSTranslator.formatMessage(messages.required);
    } else if (!isEmail(values.email)) {
        errors.email = plainJSTranslator.formatMessage(messages.invalidEmail);
    }
    if (!values.phone) {
        errors.phone = plainJSTranslator.formatMessage(messages.required);
    } else if (values.phone && !validPhoneNumber(values.phone)) {
        errors.phone = plainJSTranslator.formatMessage(messages.invalidPhone);
    }
    if (values.mobilePhone && !validPhoneNumber(values.mobilePhone)) {
        errors.mobilePhone = plainJSTranslator.formatMessage(messages.required);
    }
    if (values.directPhoneNumber && !validPhoneNumber(values.directPhoneNumber)) {
        errors.directPhoneNumber = plainJSTranslator.formatMessage(messages.required);
    }

    errors = validateMaxLength({values, errors, length: 255, fields: [
        'workingTitle',
        'name',
        'email',
        'linkedIn',
        'facebook',
        'instagram',
        'twitter',
    ]});

    return errors
};

function validPhoneNumber(phone) {
    return phone.length === 8;
}


// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonValidator.js